module.exports = __webpack_public_path__ + "static/media/genuine-background-EN.80820eaa.png";